import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "theme";

const globalStyles = css`
  .MuiBackdrop-root,
  MuiDialog-backdrop {
    background-color: transparent !important;
  }
  .MuiDialogContent-root {
    padding: 0px !important;
  }

  .MuiListItemIcon-root {
    min-width: 40px !important;
  }

  .MuiModal-root,
  MuiDialog-root {
    z-index: 2100 !important;
  }
`;

const InputField = styled.input`
  width: 85%;
  height: 33px;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid ${theme.colors.bordertask};
  &:focus {
    border-color: ${theme.colors.bordertask};
  }
`;

const DialogContent = styled.div`
  width: 300px;
  height: 270px;
`;
const DialogTitle = styled.p`
  padding: 15px;
  margin: 0;
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
  InputField,
  DialogContent,
  DialogTitle,
};

export default SC;
